import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'absolute',
      top: '20px',
      height: '1em',
      right: 0,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      marginTop: -4,
      marginRight: 4,

      pointerEvents: 'none',
      zIndex: theme.zIndex.absoluteElement,
    },
    button: {
      pointerEvents: 'auto',
    },
  }),
  { name: 'ContinueRowFloatingPanel' }
);
